import { render } from "./MyLife.vue?vue&type=template&id=67da3b42&scoped=true"
import script from "./MyLife.vue?vue&type=script&lang=js"
export * from "./MyLife.vue?vue&type=script&lang=js"

import "./MyLife.vue?vue&type=style&index=0&id=67da3b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67da3b42"]])

export default __exports__